import type { ReactElement } from 'react';
import {
  AppsListFilled,
  AppsListRegular,
  CircleFilled,
  CircleRegular,
  DataBarVerticalFilled,
  DataBarVerticalRegular,
  HomeRegular,
  ListBarFilled,
  ListBarRegular,
  ServerFilled,
  ServerRegular,
  ShieldCheckmarkFilled,
  ShieldCheckmarkRegular,
  WindowDevEditFilled,
  WindowDevEditRegular,
  bundleIcon,
} from '@fluentui/react-icons';
import type { IconKey } from '@unified-governance/shared';

const RequestsIcon = bundleIcon(ListBarFilled, ListBarRegular);
const AppsIcon = bundleIcon(AppsListFilled, AppsListRegular);
const RiskIcon = bundleIcon(ShieldCheckmarkFilled, ShieldCheckmarkRegular);
const DeveloperIcon = bundleIcon(WindowDevEditFilled, WindowDevEditRegular);
const AdminIcon = bundleIcon(ServerFilled, ServerRegular);
const ReportsIcon = bundleIcon(DataBarVerticalFilled, DataBarVerticalRegular);
const FallbackIcon = bundleIcon(CircleFilled, CircleRegular);

const iconByKey: Record<IconKey, ReactElement> = {
  home: <HomeRegular fontSize={20} />,
  requests: <RequestsIcon />,
  apps: <AppsIcon />,
  riskAssessment: <RiskIcon />,
  developer: <DeveloperIcon />,
  admin: <AdminIcon />,
  reports: <ReportsIcon />,
};

export function getIcon(key?: IconKey, dataUrl?: string): ReactElement {
  if (dataUrl) {
    return (
      <img
        alt=""
        aria-hidden="true"
        height={20}
        src={dataUrl}
        width={20}
      />
    );
  }
  if (key && key in iconByKey) {
    return iconByKey[key];
  }
  return <FallbackIcon />;
}
